import React from 'react';

function Privacy() {
  return (
    <div className="bg-gradient-primary min-vh-100">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10 col-lg-12 col-md-9">
            
            {/* 헤더 */}
            <div className="text-center py-5">
              <h1 className="h1 text-white mb-4">
                <i className="fas fa-shield-alt me-3"></i>
                개인정보 처리방침
              </h1>
              <p className="lead text-white-50 mb-0">
                노후 준비 연금 계산기의 개인정보 보호 정책
              </p>
            </div>

            {/* 개인정보 처리방침 내용 */}
            <div className="card shadow mb-5">
              <div className="card-header py-3">
                <h3 className="m-0 font-weight-bold text-primary">
                  <i className="fas fa-info-circle me-2"></i>
                  개인정보 처리방침 개요
                </h3>
              </div>
              <div className="card-body">
                <div className="alert alert-success">
                  <h5 className="alert-heading">
                    <i className="fas fa-check-circle me-2"></i>
                    개인정보 비수집 서비스
                  </h5>
                  <p className="mb-0">
                    <strong>노후 준비 연금 계산기</strong>는 사용자의 개인정보를 수집하지 않습니다. 
                    모든 계산은 브라우저에서 실시간으로 처리되며, 입력 데이터는 서버에 저장되지 않습니다.
                  </p>
                </div>
                
                <p className="text-gray-700">
                  최종 수정일: 2025년 9월 17일<br/>
                  시행일: 2025년 9월 17일
                </p>
              </div>
            </div>

            {/* 수집하는 정보 */}
            <div className="card shadow mb-5">
              <div className="card-header py-3">
                <h3 className="m-0 font-weight-bold text-primary">
                  1. 수집하는 개인정보의 항목
                </h3>
              </div>
              <div className="card-body">
                <h5 className="mb-3">📊 계산기 사용 시</h5>
                <div className="alert alert-info">
                  <ul className="mb-0">
                    <li><strong>수집하지 않는 정보:</strong> 이름, 나이, 연락처, 이메일 등 개인 식별 정보</li>
                    <li><strong>저장하지 않는 정보:</strong> 계산에 입력한 모든 수치 (나이, 저축액, 수익률 등)</li>
                    <li><strong>추적하지 않는 정보:</strong> IP 주소, 브라우저 정보, 접속 로그 등</li>
                  </ul>
                </div>

                <h5 className="mt-4 mb-3">📧 문의 양식 사용 시</h5>
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead className="bg-light">
                      <tr>
                        <th>수집 항목</th>
                        <th>수집 목적</th>
                        <th>보유 기간</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>이름, 이메일</td>
                        <td>문의 답변 및 서비스 개선</td>
                        <td>문의 처리 완료 후 6개월</td>
                      </tr>
                      <tr>
                        <td>문의 내용</td>
                        <td>서비스 개선 및 오류 수정</td>
                        <td>문의 처리 완료 후 6개월</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* 이용목적 */}
            <div className="card shadow mb-5">
              <div className="card-header py-3">
                <h3 className="m-0 font-weight-bold text-primary">
                  2. 개인정보의 수집 및 이용목적
                </h3>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <div className="card bg-light h-100">
                      <div className="card-body">
                        <h5 className="text-success">
                          <i className="fas fa-calculator me-2"></i>
                          계산기 서비스
                        </h5>
                        <ul className="mb-0">
                          <li>연금 계산 기능 제공</li>
                          <li>시뮬레이션 결과 표시</li>
                          <li>차트 및 표 생성</li>
                          <li><strong>개인정보 수집 없음</strong></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="card bg-light h-100">
                      <div className="card-body">
                        <h5 className="text-primary">
                          <i className="fas fa-envelope me-2"></i>
                          문의 처리
                        </h5>
                        <ul className="mb-0">
                          <li>문의 접수 및 답변</li>
                          <li>서비스 개선 사항 수집</li>
                          <li>기술적 문제 해결</li>
                          <li>사용자 의견 반영</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 제3자 제공 */}
            <div className="card shadow mb-5">
              <div className="card-header py-3">
                <h3 className="m-0 font-weight-bold text-primary">
                  3. 개인정보의 제3자 제공
                </h3>
              </div>
              <div className="card-body">
                <div className="alert alert-warning">
                  <h5 className="alert-heading">
                    <i className="fas fa-lock me-2"></i>
                    제3자 제공 금지
                  </h5>
                  <p className="mb-0">
                    본 서비스는 수집한 개인정보를 <strong>어떠한 제3자에게도 제공하지 않습니다</strong>. 
                    단, 법령에 의해 요구되는 경우에 한하여 관련 기관에 제공할 수 있습니다.
                  </p>
                </div>
              </div>
            </div>

            {/* 외부 서비스 */}
            <div className="card shadow mb-5">
              <div className="card-header py-3">
                <h3 className="m-0 font-weight-bold text-primary">
                  4. 외부 서비스 이용
                </h3>
              </div>
              <div className="card-body">
                <h5 className="mb-3">🌐 사용 중인 외부 서비스</h5>
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead className="bg-light">
                      <tr>
                        <th>서비스</th>
                        <th>제공사</th>
                        <th>용도</th>
                        <th>개인정보 수집</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Firebase Hosting</td>
                        <td>Google</td>
                        <td>웹사이트 호스팅</td>
                        <td>접속 로그만 수집</td>
                      </tr>
                      <tr>
                        <td>Google Fonts</td>
                        <td>Google</td>
                        <td>폰트 제공</td>
                        <td>없음</td>
                      </tr>
                      <tr>
                        <td>Bootstrap CDN</td>
                        <td>Bootstrap Team</td>
                        <td>CSS 프레임워크</td>
                        <td>없음</td>
                      </tr>
                      <tr>
                        <td>Chart.js CDN</td>
                        <td>Chart.js Community</td>
                        <td>차트 라이브러리</td>
                        <td>없음</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* 보안 조치 */}
            <div className="card shadow mb-5">
              <div className="card-header py-3">
                <h3 className="m-0 font-weight-bold text-primary">
                  5. 개인정보 보호를 위한 기술적/관리적 조치
                </h3>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <h5 className="text-primary">
                      <i className="fas fa-shield-alt me-2"></i>
                      기술적 조치
                    </h5>
                    <ul>
                      <li>HTTPS 보안 통신</li>
                      <li>클라이언트 사이드 계산</li>
                      <li>서버 데이터 미저장</li>
                      <li>정기적 보안 업데이트</li>
                    </ul>
                  </div>
                  <div className="col-md-6 mb-3">
                    <h5 className="text-success">
                      <i className="fas fa-users me-2"></i>
                      관리적 조치
                    </h5>
                    <ul>
                      <li>최소 개인정보 수집 원칙</li>
                      <li>데이터 처리 목적 명시</li>
                      <li>보유 기간 준수</li>
                      <li>정기적 개인정보 처리방침 검토</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* 권리 행사 */}
            <div className="card shadow mb-5">
              <div className="card-header py-3">
                <h3 className="m-0 font-weight-bold text-primary">
                  6. 개인정보 관련 권리 행사
                </h3>
              </div>
              <div className="card-body">
                <p className="text-gray-700 mb-4">
                  정보주체는 언제든지 다음과 같은 권리를 행사할 수 있습니다:
                </p>
                
                <div className="row">
                  <div className="col-lg-6 mb-3">
                    <div className="card border-primary h-100">
                      <div className="card-body">
                        <h6 className="text-primary">
                          <i className="fas fa-search me-2"></i>
                          열람 요구권
                        </h6>
                        <p className="mb-0 small">개인정보 처리 현황을 확인할 수 있습니다.</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 mb-3">
                    <div className="card border-success h-100">
                      <div className="card-body">
                        <h6 className="text-success">
                          <i className="fas fa-edit me-2"></i>
                          정정·삭제권
                        </h6>
                        <p className="mb-0 small">개인정보의 수정이나 삭제를 요구할 수 있습니다.</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="alert alert-info mt-3">
                  <p className="mb-2">
                    <strong>권리 행사 방법:</strong>
                  </p>
                  <ul className="mb-0">
                    <li>문의 페이지를 통한 온라인 신청</li>
                    <li>본인 확인 절차 후 처리 (영업일 기준 10일 이내)</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 연락처 */}
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <h3 className="m-0 font-weight-bold text-primary">
                  7. 개인정보 관련 문의
                </h3>
              </div>
              <div className="card-body text-center">
                <p className="text-gray-600 mb-4">
                  개인정보 처리방침에 대한 문의사항이나 개인정보 관련 권리 행사를 원하시는 경우 
                  문의 페이지를 통해 연락해 주시기 바랍니다.
                </p>
                <button className="btn btn-primary">
                  <i className="fas fa-envelope me-2"></i>
                  문의하기
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default Privacy;